import { render, staticRenderFns } from "./ArticleSeoBasicStep.vue?vue&type=template&id=b3139a90&"
import script from "./ArticleSeoBasicStep.vue?vue&type=script&lang=js&"
export * from "./ArticleSeoBasicStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports